import { render, staticRenderFns } from "./jumuserprotocol.vue?vue&type=template&id=26bcd310&scoped=true"
import script from "./jumuserprotocol.vue?vue&type=script&lang=js"
export * from "./jumuserprotocol.vue?vue&type=script&lang=js"
import style0 from "./jumuserprotocol.vue?vue&type=style&index=0&id=26bcd310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bcd310",
  null
  
)

export default component.exports